<router-outlet></router-outlet>
<div bsModal #childModal="bs-modal" class="modal fade" tabindex="-1"
     role="dialog" [config]="{backdrop: 'static',  keyboard: false}" aria-labelledby="dialog-child-name" aria-hidden="true">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="dialog-child-name" class="modal-title pull-left">Your session is about to expire!</h4>
        <!-- <button type="button" class="close pull-right" aria-label="Close" (click)="hideChildModal()">
          <span aria-hidden="true">&times;</span>
        </button> -->
      </div>
      <div class="modal-body">
         {{idleState}}
        <div class="row mrgbtm" style="padding-top: 4%;padding-bottom: 2%;">
          <div class="col-md-2" style="margin-right: 3%;">
            <button type="button" (click)="stay()" class="primary-color ct-btn primary-btn">Continue</button>
          </div>
          <div class="col-md-2">
              <button type="button" (click)="logout()" class="secondary-color">Logout</button>
          </div>          
        </div>
      </div>
    </div>
  </div>
</div>
<!-- loader -->
<div class="spinner-holder" [hidden]="!store.loading">
    <div class="spinner spinner-border text-primary"></div>
</div>
